module.exports = __webpack_public_path__ + "b35fd8e1a262d49862daa44b80af1b84.woff";